import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { IUser } from '../../../model/user/IUser';
import { toast } from 'react-toastify';
import { AgencyService } from '../AgencyService';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { LocalRoutes } from '../../../enum/LocalRoutes';
import { ADDED_USER, UPDATED_USER } from '../../../enum/Messages';
import { ErrorToast } from '../../../utils/toasters';
import CardLayout from '../../../shared/components/CardLayout';

export function FormAgency() {
    const navigate = useNavigate();
    const { country } = useSelector((state: any) => state.enums);
    const { agencyId } = useParams() as { agencyId: string };
    const [user, setUser] = useState<Partial<IUser>>({});
    const [validated, setValidated] = useState(false);

    useEffect(() => {
        if (agencyId) {
            AgencyService.getAgency(+agencyId)
                .then(data => {
                    setUser(data);
                })
                .catch(err => ErrorToast(err));
        }
    }, []);

    const editUser = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        setValidated(true);

        AgencyService.editAgency(+agencyId, user)
            .then(data => {
                setUser(data);
                toast(UPDATED_USER);
            })
            .catch(err => ErrorToast(err));
    };

    function createUser(event: any) {
        event.preventDefault();
        setValidated(true);
        AgencyService.createAgency(user)
            .then(data => {
                if (data.id) {
                    navigate(LocalRoutes.AGENCY_LIST);
                }
                toast(ADDED_USER);
            })
            .catch(err => ErrorToast(err));
    }

    function handleChange(evt: any, isContact = false) {
        const { value, name } = evt.target;

        setUser(prevUser => {
            if (isContact) {
                return {
                    ...prevUser,
                    contact: {
                        ...prevUser.contact,
                        [name]: value,
                    } as IUser['contact'],
                };
            } else {
                return {
                    ...prevUser,
                    [name]: value,
                };
            }
        });
    }

    return (
        <Form onSubmit={agencyId ? editUser : createUser} noValidate validated={validated}>
            <CardLayout classCard="mb-5">
                <h3>Company info</h3>
                <hr />
                <Row>
                    <Form.Group as={Col} className="mb-0">
                        <Form.Label>Email</Form.Label>
                        <Form.Control required name="email" onChange={handleChange} value={user?.email} />
                    </Form.Group>

                    <Form.Group as={Col} className="mb-0">
                        <Form.Label>Display name</Form.Label>
                        <Form.Control required name="displayName" onChange={handleChange} value={user?.displayName} />
                    </Form.Group>
                </Row>
            </CardLayout>

            {/*CONTACT*/}

            <CardLayout classCard="mb-5">
                <h3>Contact</h3>
                <hr />
                <Row>
                    <Form.Group as={Col}>
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                            name="phone"
                            onChange={e => handleChange(e, true)}
                            value={user?.contact?.phone ?? ''}
                        />
                    </Form.Group>

                    <Form.Group as={Col}>
                        <Form.Label>Street, House Number, Appartment Number</Form.Label>
                        <Form.Control
                            name="street"
                            onChange={e => handleChange(e, true)}
                            value={user?.contact?.street}
                        />
                    </Form.Group>
                </Row>

                <Row>
                    <Form.Group as={Col}>
                        <Form.Label>Postal Code</Form.Label>
                        <Form.Control name="zip" onChange={e => handleChange(e, true)} value={user?.contact?.zip} />
                    </Form.Group>

                    <Form.Group as={Col}>
                        <Form.Label>City</Form.Label>
                        <Form.Control name="city" onChange={e => handleChange(e, true)} value={user?.contact?.city} />
                    </Form.Group>
                </Row>

                <Row>
                    <Form.Group as={Col}>
                        <Form.Label>State</Form.Label>
                        <Form.Control
                            name="province"
                            onChange={e => handleChange(e, true)}
                            value={user?.contact?.province}
                        />
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridState">
                        <Form.Label>Country</Form.Label>
                        <Form.Select
                            name="country"
                            onChange={e => handleChange(e, true)}
                            value={user?.contact?.country}
                        >
                            {country?.map((country: string) => (
                                <option key={country}>{country}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Row>

                <Row>
                    <Form.Group className="col-md-6 mb-0">
                        <Form.Label>VAT number</Form.Label>
                        <Form.Control
                            name="uidNumber"
                            onChange={e => handleChange(e, true)}
                            value={user?.contact?.uidNumber}
                        />
                    </Form.Group>
                </Row>
            </CardLayout>
            <Button size="lg" type="submit">
                Save
            </Button>
        </Form>
    );
}
